import { env } from './env';

export const API_BASE_URL = env.apiBaseUrl;

// API Endpoints
export const API_ENDPOINTS = {
  //POLLING
  CHECK: {
    MINT_STATUS: (jobID) => `/omniverse/check-job-status?jobid=${jobID}`,
  },
  // Articles
  ARTICLES: {
    GET_ALL: '/omniverse/list/asset/particle?status=active',
    GET_BY_ID: (id) => `/omniverse/read/asset/particle/${id}`,
    GET_BY_CREATOR: (creator) =>
      `/omniverse/list/assets/particle/user/${creator}`,
    GET_BY_TOPIC: (topic) => `/articles/topic/${encodeURIComponent(topic)}`,
    CREATE: '/omniverse/create/asset/particle',
    UPDATE: (id) => `/articles/${id}`,
    DELETE: (id) => `/articles/${id}`,
    LIKE: (id) => `/omniverse/interact`,
    DISLIKE: (id) => `/omniverse/interact`,
  },

  // Comments
  COMMENTS: {
    // OID for creation and fetching (works for both particles and discussions)
    GET_BY_OID: (oid) => `/omniverse/discussions/${oid}/comments`,
    ADD: (oid) => `/omniverse/discussions/${oid}/comments`,
    // Comment OID for replies
    ADD_REPLY: (commentOid) => `/omniverse/comments/${commentOid}/replies`,
    GET_REPLIES: (commentOid) =>
      `/omniverse/comments/${commentOid}/replies`,
    // Comment actions
    LIKE: (commentOid) => `/omniverse/comments/${commentOid}/like`,
    DISLIKE: (commentOid) => `/omniverse/comments/${commentOid}/dislike`,
    UPDATE: (commentOid) => `/omniverse/comments/${commentOid}`,
    DELETE: (commentOid) => `/omniverse/comments/${commentOid}`,
    // Get by ID and by user
    GET_BY_ID: (commentOid) => `/omniverse/comments/${commentOid}`,
    GET_BY_USER: (userId) => `/omniverse/comments/user/${userId}`,
  },

  // Users/Profiles
  USERS: {
    GET_BY_ID: (id) => `/omniverse/user/${id}`,
    GET_FOLLOWERS: (userId) => `/users/${userId}/followers`,
    GET_FOLLOWING: (userId) => `/users/${userId}/following`,
    UPDATE_PROFILE: (id) => `/omniverse/user/${id}`,
    FOLLOW: (userId) => `/omniverse/user/${userId}/follow`,
    UNFOLLOW: (userId) => `/users/${userId}/unfollow`,
    GET_VIEW_STATS: (id) => `/omniverse/user/${id}/view-stats`,
    GET_CONTENT_VIEW_STATUS: (contentOid) =>
      `/omniverse/content/${contentOid}/view-status`,
    CHECK_USERNAME: (username) =>
      `/omniverse/user/checkusername?username=${encodeURIComponent(
        username
      )}`,
  },

  // Topics
  TOPICS: {
    GET_ALL: '/topics',
    GET_BY_SLUG: (slug) => `/topics/${slug}`,
    GET_POPULAR: '/topics/popular',
  },

  // categories
  CATEGORIES: {
    GET_ALL: '/omniverse/categories/get-all-categories',
    ADD_CATEGORY: '/omniverse/categories/add-category', // POST (single or array)
    ADD_PINNED_MESSAGE: '/omniverse/categories/:categoryId/pin', // POST
    PIN_DISCUSSION: '/omniverse/categories/pin-discussion', // PUT
    UNPIN_DISCUSSION: '/omniverse/categories/unpin-discussion', // PUT
    CHANGE_RULES: '/omniverse/categories/:categoryId/rules', // PUT
    SET_LOCK: '/omniverse/categories/:categoryId/lock', // PUT
    CHANGE_NAME: '/omniverse/categories/:categoryId/name', // PUT
  },

  // Search
  SEARCH: {
    ARTICLES: (term) => `/search/articles?q=${encodeURIComponent(term)}`,
    USERS: (term) => `/search/users?q=${encodeURIComponent(term)}`,
    TOPICS: (term) => `/search/topics?q=${encodeURIComponent(term)}`,
  },

  // Auth
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    LOGOUT: '/auth/logout',
    CURRENT_USER: '/auth/me',
  },

  // Notifications
  INTERACTIONS: {
    GET_ALL: '/omniverse/notifications',
    MARK_READ: (id) => `/notifications/${id}/read`,
    MARK_ALL_READ: '/notifications/read-all',
    GET_All_BY_USER_ID: (userId) =>
      `/omniverse/getalluserinteractions?oid=${userId}`,
    GET_GIVEN_BY_USER_OID: (userOid) =>
      `/omniverse/getuserinteractionsgiven?oid=${userOid}`,
  },

  // Notifications
  NOTIFICATIONS: {
    GET_ALL: '/omniverse/notifications',
    UNREAD_COUNT: '/omniverse/notifications/unread-count',
    MARK_READ: (id) => `/omniverse/notifications/${id}/read`,
    MARK_ALL_READ: '/omniverse/notifications/read-all',
    DELETE: (id) => `/omniverse/notifications/${id}`,
    GET_PREFERENCES: '/omniverse/notifications/preferences',
    UPDATE_PREFERENCES: '/omniverse/notifications/preferences',
  },

  // Appeals
  APPEALS: {
    SUBMIT: '/omniverse/appeal',
    MY_APPEALS: '/omniverse/appeal/my-appeals',
    GET_BY_ID: (id) => `/omniverse/appeal/${id}`,
    WITHDRAW: (id) => `/omniverse/appeal/${id}/withdraw`,
    ADMIN: {
      GET_ALL: '/admin/appeals',
      REVIEW: (id) => `/admin/appeals/${id}/review`,
      APPROVE: (id) => `/admin/appeals/${id}/approve`,
      REJECT: (id) => `/admin/appeals/${id}/reject`,
    },
  },

  // Forum
  FORUM: {
    DISCUSSIONS: {
      GET_ALL: '/omniverse/list/asset/discussion',
      GET_BY_OID: (id) => `/omniverse/read/asset/discussion/${id}`,
      GET_BY_CATEGORY: (categoryId) =>
        `/forum/discussion/category/${categoryId}`,
      GET_BY_AUTHOR: (authorId) => `/forum/discussion/author/${authorId}`,
      CREATE: '/omniverse/create/asset/discussion',
      UPDATE: (id) => `/forum/discussion/${id}`,
      DELETE: (id) => `/forum/discussion/${id}`,
      UPVOTE: (id) => `/omniverse/interact`,
      DOWNVOTE: (id) => `/omniverse/interact`,
      COMMENT: (discussionOid) =>
        `/omniverse/discussions/${discussionOid}/comments`,
      FREEZE_DISCUSSION: '/omniverse/discussion/freeze-discussion', // PUT
      UNFREEZE_DISCUSSION: '/omniverse/discussion/unfreeze-discussion', // PUT
      ADD_VIEW: '/omniverse/discussion/add-view', // POST
      DELETE_DISCUSSION: (id) => `/omniverse/delete/asset/discussion/${id}`,
      RESTORE_DISCUSSION: (id) =>
        `/omniverse/restore/asset/discussion/${id}`,
    },
    ACTIVITY: {
      GET_USER_ACTIVITY: (userOID) => `/omniverse/activity/user/${userOID}`,
      GET_USER_STATS: (userOID) =>
        `/omniverse/activity/user/${userOID}/stats`,
    },
    CATEGORIES: {
      GET_ALL: '/forum/categories',
      GET_BY_ID: (id) => `/forum/categories/${id}`,
      GET_BY_SLUG: (slug) => `/forum/categories/${slug}`,
    },
    COMMENTS: {
      GET_BY_DISCUSSION: (discussionOid) =>
        `/omniverse/discussions/${discussionOid}/comments`,
      ADD: '/forum/comments',
      UPVOTE: (id) => `/forum/comments/${id}/upvote`,
      DOWNVOTE: (id) => `/forum/comments/${id}/downvote`,
    },
  },

  // Badges
  BADGES: {
    GET_ALL: '/omniverse/badges',
    GET_BY_SLUG: (slug) => `/omniverse/badges/badge/${slug}`,
    GET_USER_BADGES: (userAddress) =>
      `/omniverse/badges/user/${userAddress}`,
    GET_USER_BADGES_WITH_SYNC: (userAddress) =>
      `/omniverse/badges/user/${userAddress}?sync=true`,
    GET_USER_BADGES_BY_OID: (oid) => `/omniverse/badges/user/oid/${oid}`,
    SYNC_USER_BADGES: (userAddress) =>
      `/omniverse/badges/check/${userAddress}`,
    TOGGLE_FEATURED: (badgeSlug) =>
      `/omniverse/badges/badge/${badgeSlug}/toggle-featured`,
    SET_TITLE: (badgeSlug) =>
      `/omniverse/badges/badge/${badgeSlug}/set-title`,
    REMOVE_TITLE: '/omniverse/badges/remove-title',
    // Admin
    ADMIN: {
      STATS: '/omniverse/badges/admin/stats',
      CREATE: '/omniverse/badges/admin/create',
      UPDATE: (slug) => `/omniverse/badges/admin/badge/${slug}`,
      DELETE: (slug) => `/omniverse/badges/admin/badge/${slug}`,
      GRANT: (slug) => `/omniverse/badges/admin/badge/${slug}/grant`,
      REVOKE: (slug) => `/omniverse/badges/admin/badge/${slug}/revoke`,
      SYNC_ALL: '/omniverse/badges/admin/check-all',
    },
  },

  // Communities (Discover page) - MongoDB stored, not DKG minted
  COMMUNITIES: {
    GET_ALL: '/omniverse/communities',
    GET_BY_ID: (id) => `/omniverse/communities/${id}`,
    GET_BY_OID: (oid) => `/omniverse/communities/oid/${oid}`,
    GET_BY_SLUG: (slug) => `/omniverse/communities/slug/${slug}`,
    GET_BY_CATEGORY: (category) =>
      `/omniverse/communities/category/${category}`,
    CREATE: '/omniverse/communities/create',
    UPDATE: (oid) => `/omniverse/communities/${oid}`,
    DELETE: (oid) => `/omniverse/communities/${oid}`,
    JOIN: (oid) => `/omniverse/communities/${oid}/join`,
    LEAVE: (oid) => `/omniverse/communities/${oid}/leave`,
    GET_MEMBERS: (oid) => `/omniverse/communities/${oid}/members`,
    GET_STAFF: (oid) => `/omniverse/communities/${oid}/staff`,
    GET_STATS: (oid) => `/omniverse/communities/${oid}/stats`,
    GET_USER_COMMUNITIES: (userOid) =>
      `/omniverse/communities/user/${userOid}`,
    GET_DISCUSSIONS: (oid) => `/omniverse/communities/${oid}/discussions`,
    CHECK_MEMBERSHIP: (oid, userOid) =>
      `/omniverse/communities/${oid}/membership/${userOid}`,
  },
};

export const apiConfig = {
  baseUrl: API_BASE_URL,
  endpoints: API_ENDPOINTS,
};
